module.exports = __webpack_public_path__ + "img/emoji_dying.d7f9e894.svg";